<template>
  <v-app id="app">
    <v-app-bar app color="grey lighten-5" flat v-if="loggedIn">
      <v-toolbar-title style="width: 300px" class="ml-0">
        <v-img src="/img/logo.png" alt="" width="69" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <AppMenu />

      <span class="d-flex d-sm-none">XS</span>
      <span class="d-none d-sm-flex d-md-none">SM</span>
      <span class="d-none d-md-flex d-lg-none">MD</span>
      <span class="d-none d-lg-flex d-xl-none">LG</span>
      <span class="d-none d-xl-flex">XL</span>

      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>

      <Auth-status />
    </v-app-bar>

    <v-content v-if="loggedIn">
      <v-container class="fill-height grey lighten-5 d-flex align-start pa-0 px-md-4" fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-content v-else>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
  import AppMenu from "@/components/AppMenu.vue";
  import AuthStatus from "@/views/auth/Status.vue";
  import menuItems from "@/router/menuitems.js";
  import EventBus from "./event-bus";
  import { mapGetters } from "vuex";

  export default {
    components: {
      AppMenu,
      AuthStatus,
    },
    props: {
      source: String,
    },
    created() {
      let user = JSON.parse(localStorage.getItem("user"));
      this.$store.dispatch("setUserData", user);
    },
    data: () => ({
      transitionName: "",
      fab: false,
      dialog: false,
      drawer: null,
    }),
    computed: {
      ...mapGetters(["user", "loggedIn"]),
      menuItems() {
        return menuItems[this.$route.meta.menu];
      },
    },
  };
</script>

<style lang="scss">
  html {
    --scrollbarBG: rgb(250, 250, 250);
    --thumbBG: grey;
  }

  body {
    scrollbar-width: thick;
    scrollbar-color: var(--thumbBG) var(--scrollbarBG);
  }

  body::-webkit-scrollbar {
    width: 1rem;
  }

  body::-webkit-scrollbar-track {
    background: var(--scrollbarBG);
  }
  body::-webkit-scrollbar-thumb {
    background-color: var(--thumbBG);
    border-radius: 3px;
    border: 1px solid var(--scrollbarBG);
  }

  // this is just a quick fix until Vuetify does it correctly. icon in dense outlined input field dose not stay in line

  .v-text-field.v-input--dense .v-input__prepend-inner .v-input__icon > .v-icon,
  .v-text-field.v-input--dense .v-input__append-inner .v-input__icon > .v-icon {
    margin-top: 0 !important;
  }

  // hacks for mobile v-data-table
  .theme--light.v-datatable .v-datatable__actions {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .theme--light.v-data-table .v-data-footer {
    padding: 0;
  }

  .v-application--is-ltr .v-data-footer > .v-data-footer__select {
    margin-right: 0px;
  }

  .v-data-table td,
  .v-data-table th {
    padding: 0 !important;
    margin: 0 !important;
  }
</style>
